import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownGridPicker } from './DropdownGridPicker';

interface DropdownMonthPickerProps {
  height: number,
  isSelectable: (month: DateTime) => boolean,
  monthAndYear: DateTime,
  onMonthChange: (month: number) => void,
}

export const DropdownMonthPicker = ({
  height,
  isSelectable,
  monthAndYear,
  onMonthChange,
}: DropdownMonthPickerProps) => {
  const { i18n } = useTranslation();
  const months = useMemo(
    () => Array.from({ length: 12 }, (_, monthIndex) => ({
      id: `calendar-month-picker-${monthIndex}`,
      label: DateTime.local()
        .set({ month: monthIndex + 1 })
        .setLocale(i18n.language)
        .toFormat('MMM'),
      value: monthIndex + 1,
    })),
    [i18n.language],
  );
  const items = months.map((month) => ({
    ...month,
    isDisabled: !isSelectable(monthAndYear.set({ month: month.value })),
  }));

  return (
    <DropdownGridPicker
      height={height}
      items={items}
      onSelect={onMonthChange}
      selectedValue={monthAndYear.month}
    />
  );
};
